import { executeReport, REPORT_TYPES } from '../../../../../../../../../../logic/utils/reportRequest';

export default async function SqlQuery(startTime, endTime) {
  // Получаем данные через новый API
  const result = await executeReport(REPORT_TYPES.GENERAL_OPERATOR_TABLE, { startTime, endTime });

  // Возвращаем в том же формате для обратной совместимости
  return {
    dataObjects: [],
    query: result.query,
    data: result.dataObjects,
  };
}
